import React, { useEffect, useState } from 'react';

const CustomCursor: React.FC = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        // Check if device has touch capability (coarse pointer)
        const checkTouch = () => {
            setIsTouch(window.matchMedia('(pointer: coarse)').matches);
        };

        checkTouch();
        window.addEventListener('resize', checkTouch);

        const updatePosition = (e: MouseEvent) => {
            if (isTouch) return;
            setPosition({ x: e.clientX, y: e.clientY });
            if (!isVisible) setIsVisible(true);
        };

        const handleMouseEnter = () => setIsVisible(true);
        const handleMouseLeave = () => setIsVisible(false);

        // Check for hover targets
        const handleMouseOver = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (
                target.tagName === 'A' ||
                target.tagName === 'BUTTON' ||
                target.closest('a') ||
                target.closest('button') ||
                target.getAttribute('role') === 'button'
            ) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener('mousemove', updatePosition);
        window.addEventListener('mouseenter', handleMouseEnter);
        window.addEventListener('mouseleave', handleMouseLeave);
        window.addEventListener('mouseover', handleMouseOver);

        return () => {
            window.removeEventListener('mousemove', updatePosition);
            window.removeEventListener('mouseenter', handleMouseEnter);
            window.removeEventListener('mouseleave', handleMouseLeave);
            window.removeEventListener('mouseover', handleMouseOver);
        };
    }, [isVisible]);

    if (isTouch || !isVisible) return null;

    return (
        <div
            className="pointer-events-none fixed z-[10000] mix-blend-difference top-0 left-0"
            style={{
                transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
            }}
        >
            {/* Central Dot */}
            <div
                className={`
          absolute -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-all duration-300 ease-out
          ${isHovering ? 'h-4 w-4' : 'h-2 w-2'}
        `}
            />

            {/* Outer Ring */}
            <div
                className={`
          absolute -translate-x-1/2 -translate-y-1/2 rounded-full border border-white transition-all duration-500 ease-out
          ${isHovering ? 'h-12 w-12 opacity-50 scale-110' : 'h-8 w-8 opacity-30'}
        `}
            />
        </div>
    );
};

export default CustomCursor;
